import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { SexualPerformanceHairLossComponent } from '@consultation-upsells/sexual-performance/hair-loss/sexual-performance-hair-loss.component';
import { SexualPerformancePeptideComponent } from '@consultation-upsells/sexual-performance/peptide/sexual-performance-peptide.component';
import { SexualPerformanceComponent } from '@consultation-upsells/sexual-performance/sexual-performance.component';
import { SexualPerformanceTrtComponent } from '@consultation-upsells/sexual-performance/trt/sexual-performance-trt.component';
import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { ConsultationStorageService } from '@services/consultation-storage.service';

/**
 * Switcher component that dynamically displays the appropriate Sexual Performance upsell component based on the
 * consultation treatment type.
 */
@Component({
  selector: 'app-sexual-performance-switcher',
  standalone: true,
  imports: [
    CommonModule,
    SexualPerformanceComponent,
    SexualPerformanceTrtComponent,
    SexualPerformancePeptideComponent,
    SexualPerformanceHairLossComponent,
  ],
  templateUrl: './sexual-performance-switcher.component.html',
})
export class SexualPerformanceSwitcherComponent {
  public readonly ConsultationTreatmentTypes: typeof ConsultationTreatmentTypes = ConsultationTreatmentTypes;

  private consultationStorageService = inject(ConsultationStorageService);

  /**
   * Gets the current treatment type from the consultation storage service.
   */
  public get treatmentType(): ConsultationTreatmentTypes {
    return this.consultationStorageService.treatmentType;
  }
}
